export default __webpack_public_path__ + "static/media/hiddenText.c7f323f9.svg";